import { landingStatusSchema, type LandingStatus } from '@koderek/shared';
import { useQuery } from '@tanstack/react-query';
import { useEffect, useRef, useState } from 'react';
import { apiGet } from '../../api/client';
import { t } from '../../texts/pl';

const NONE: LandingStatus = { available: false, version: null };

/** Czy jest strona startowa (PRD §10 pkt 37). Błąd = jakby jej nie było – `/` pokazuje wtedy listę edycji. */
export function useLanding() {
  return useQuery({
    queryKey: ['site', 'landing'],
    queryFn: async () => {
      try {
        return await apiGet('/site/landing', landingStatusSchema);
      } catch {
        return NONE;
      }
    },
    staleTime: 60_000,
  });
}

/**
 * Wklejony HTML w ramce: dokument z `/api/landing` ma własny CSP z piaskownicą (bez dostępu do sesji i API), linki otwiera
 * w całym oknie. Wysokość ramki rośnie z treścią – dokument zgłasza ją przez `postMessage` (skrypt dokłada api).
 */
export function LandingFrame({ version }: { version: string }) {
  const frame = useRef<HTMLIFrameElement>(null);
  const [height, setHeight] = useState(800);
  useEffect(() => {
    const onMessage = (event: MessageEvent) => {
      const data = event.data as { type?: unknown; height?: unknown } | null;
      if (event.source !== frame.current?.contentWindow || data?.type !== 'koderek-landing-height') return;
      if (typeof data.height === 'number' && data.height > 0) setHeight(Math.min(Math.ceil(data.height), 20_000));
    };
    window.addEventListener('message', onMessage);
    return () => window.removeEventListener('message', onMessage);
  }, []);
  return (
    <iframe
      ref={frame}
      src={`/api/landing?v=${encodeURIComponent(version)}`}
      title={t.landing.frameTitle}
      sandbox="allow-scripts allow-popups allow-popups-to-escape-sandbox allow-top-navigation-by-user-activation"
      style={{ display: 'block', width: '100%', height, border: 0 }}
    />
  );
}
